import { render } from "./pie_chart_2.svg?vue&type=template&id=553d948c"
const script = {}
script.render = render

export default script